// Application configuration from environment variables
export const appConfig = {
  appName: import.meta.env.VITE_APP_NAME || 'Hidden Adventures',
  signalrUrl: import.meta.env.VITE_SIGNALR_URL,
  enableDevTools: import.meta.env.VITE_ENABLE_DEVTOOLS === 'true',
} as const

// Export individual values for convenience
export const APP_NAME = appConfig.appName
export const SIGNALR_URL = appConfig.signalrUrl
export const ENABLE_DEVTOOLS = appConfig.enableDevTools
